package com.shadowings.gero.domain.model

import org.jetbrains.compose.resources.StringResource
import kotlin.uuid.ExperimentalUuidApi
import kotlin.uuid.Uuid

data class TrueFalseContent @OptIn(ExperimentalUuidApi::class) constructor(
    val text: QuizText,
    val correct: Boolean,
    override val id: String = Uuid.random().toHexDashString()
) : IQuizContent, ICountableQuiz {
    // Helper constructors for StringResource and String
    constructor(text: StringResource, correct: Boolean) :
        this(QuizText.Resource(text), correct)
    constructor(text: String, correct: Boolean) :
        this(QuizText.Plain(text), correct)
}

